import React from 'react';
import { motion } from 'framer-motion';

const OurServices = () => {
  const services = [
    {
      id: '01',
      title: 'Venue Booking',
      description: 'Find the perfect setting for your special day with our venue booking services. From grand banquet halls to intimate outdoor spaces, we help you choose and reserve venues that match your style, budget, and guest capacity.',
      price: 19999,
      bgColor: 'bg-slate-900',
      textColor: 'text-white',
      isHero: true
    },
    {
      id: '02',
      title: 'Event Photography',
      description: 'Capture every moment beautifully with our expert event photography team. From candid smiles to timeless portraits, we ensure your memories are preserved with high-quality images.',
      price: 2999,
      bgColor: 'bg-slate-900',
      textColor: 'text-white',
      isHero: false
    },
    {
      id: '03',
      title: 'Makeup Artist',
      description: 'Look your absolute best on your big day with our professional makeup artists. Skilled in bridal, party, and themed looks, they use premium products to enhance your natural beauty.',
      price: 3999,
      bgColor: 'bg-slate-900',
      textColor: 'text-white',
      isHero: false
    },
    {
      id: '04',
      title: 'Event Manager',
      description: 'Relax while we manage your event from start to finish. Our experienced event managers handle planning, coordination, and execution—covering decor, logistics, scheduling, and vendor management.',
      price: 4999,
      bgColor: 'bg-slate-900',
      textColor: 'text-white',
      isHero: false
    },
    // {
    //   id: '05',
    //   title: 'Catering Services',
    //   description: 'Delight your guests with a feast to remember. Our catering services offer a wide variety of cuisines and customizable menus, crafted by expert chefs.',
    //   price: 5999,
    //   bgColor: 'bg-slate-900',
    //   textColor: 'text-white',
    //   isHero: false
    // }
  ];

  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format(price);
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
    hover: { y: -8, scale: 1.02 }
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-left mb-16"
        >
          <h1 className="text-5xl md:text-6xl font-bold text-slate-900">
            Our Services
          </h1>
        </motion.div>

        {/* Services Grid */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {/* Service 01 - Hero Card */}
          <motion.div
            variants={cardVariants}
            whileHover="hover"
            transition={{ duration: 0.3 }}
            className="md:col-span-1 lg:row-span-2 cursor-pointer"
          >
            <div className={`${services[0].bgColor} ${services[0].textColor} rounded-2xl p-8 h-full relative overflow-hidden`}>
              <div className="relative z-10">
                <div className="text-6xl font-light mb-6 opacity-90">
                  {services[0].id}
                </div>
                <h3 className="text-2xl md:text-3xl font-bold mb-4 leading-tight">
                  {services[0].title}
                </h3>
                <div className="mb-6">
                  <span className="text-lg opacity-80">Starts from</span>
                  <div className="text-3xl md:text-4xl font-bold text-green-400 mt-1">
                    {formatPrice(services[0].price)}
                  </div>
                </div>
                <p className="text-base opacity-90 leading-relaxed">
                  {services[0].description}
                </p>
              </div>
            </div>
          </motion.div>

          {/* Services 02-05 */}
          {services.slice(1).map((service, index) => (
            <motion.div
              key={service.id}
              variants={cardVariants}
              whileHover="hover"
              transition={{ duration: 0.3 }}
              className="cursor-pointer"
            >
              <div className={`${service.bgColor} ${service.textColor} rounded-2xl p-8 h-full hover:shadow-lg transition-shadow duration-300`}>
                <div className="text-4xl font-light mb-4 text-gray-400">
                  {service.id}
                </div>
                <h3 className="text-xl md:text-2xl font-bold mb-4 leading-tight">
                  {service.title}
                </h3>
                <div className="mb-4">
                  <span className="text-sm opacity-70">Starts from</span>
                  <div className="text-2xl font-bold text-green-400 mt-1">
                    {formatPrice(service.price)}
                  </div>
                </div>
                <p className="text-sm leading-relaxed opacity-80">
                  {service.description}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default OurServices;